import { render, staticRenderFns } from "./ConferenceRoomHourlyStatistic.vue?vue&type=template&id=bd31dd1a"
import script from "./ConferenceRoomHourlyStatistic.vue?vue&type=script&lang=js"
export * from "./ConferenceRoomHourlyStatistic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports